module.exports = __webpack_public_path__ + "static/img/xx.5fd53ddb.png";